export default {
    hljs: {
        display: 'block',
        overflowX: 'auto',
        color: '#586e75',
    },
    'hljs-comment': {
        color: '#408080',
        fontStyle: 'italic',
    },
    'hljs-quote': {
        color: '#408080',
        fontStyle: 'italic',
    },
    'hljs-keyword': {
        color: '#954121',
    },
    'hljs-selector-tag': {
        color: '#954121',
    },
    'hljs-literal': {
        color: '#954121',
    },
    'hljs-subst': {
        color: '#954121',
    },
    'hljs-number': {
        color: '#2aa198',
    },
    'hljs-string': {
        color: '#219161',
    },
    'hljs-doctag': {
        color: '#219161',
    },
    'hljs-selector-id': {
        color: '#6c71c4',
    },
    'hljs-selector-class': {
        color: '#6c71c4',
    },
    'hljs-section': {
        color: '#6c71c4',
    },
    'hljs-type': {
        color: '#6c71c4',
    },
    'hljs-params': {
        color: '#00f',
    },
    'hljs-title': {
        color: '#458',
        fontWeight: 'bold',
    },
    'hljs-tag': {
        color: '#073642',
        fontWeight: 'normal',
    },
    'hljs-name': {
        color: '#073642',
        fontWeight: 'normal',
    },
    'hljs-attribute': {
        color: '#073642',
        fontWeight: 'normal',
    },
    'hljs-variable': {
        color: '#008080',
    },
    'hljs-template-variable': {
        color: '#008080',
    },
    'hljs-regexp': {
        color: '#b68',
    },
    'hljs-link': {
        color: '#b68',
    },
    'hljs-symbol': {
        color: '#990073',
    },
    'hljs-bullet': {
        color: '#990073',
    },
    'hljs-built_in': {
        color: '#d33682',
    },
    'hljs-builtin-name': {
        color: '#d33682',
    },
    'hljs-meta': {
        color: '#999',
        fontWeight: 'bold',
    },
    'hljs-deletion': {
        background: '#fdd',
    },
    'hljs-addition': {
        background: '#dfd',
    },
    'hljs-emphasis': {
        fontStyle: 'italic',
    },
    'hljs-strong': {
        fontWeight: 'bold',
    },
};
